module.exports = __webpack_public_path__ + "img/dashed_04.784fb0cd.png";